export default __webpack_public_path__ + "static/media/creativity_active.2f060c67.svg";